<template>
  <!-- 上传作品 -->
  <div class="gerenzxthree">
    <!-- 作品信息 -->
    <div class="grthree-zpxinxi">
      <div class="grthree-zpxinxi-title"><i></i> <span>作品信息</span></div>
      <div class="grthree-zpxinxi-data">
        <!-- 作品名称 -->
        <div class="grthree-zpxinxi-data-name">
          <el-input
            placeholder="请输入作品名称"
            v-model="threezpname"
          ></el-input>
        </div>

        <!-- 选择作品类型 -->
        <div class="grzxthree-sel">
          <el-select value-key="id" v-model="threezpclass" placeholder="请选择">
            <el-option
              v-for="item in threezpoption"
              :key="item.id"
              :label="item.type"
              :value="item"
            >
            </el-option>
          </el-select>
        </div>

        <!-- 作品信息 -->
        <div class="grthree-zpxinxi-data-text">
          <el-input
            type="textarea"
            placeholder="请输入内容"
            v-model="threetextarea"
            maxlength="80字"
            show-word-limit
            :rows="4"
            resize="none"
          >
          </el-input>
        </div>


         <div class="grthree-upload-all-uplode brr">
          <el-upload
            class="avatar-uploader"
           :action="beforup"
            :show-file-list="false"
            :on-success="handleAvatarSuccessjpg"
            :before-upload="beforeAvatarUploadjpg"
            accept=".jpg,.jpeg,.png"

          >
            <img v-if="imgurl1" :src="imgurl1" class="avatar" />
            <i v-else class="el-icon-upload"></i>
          </el-upload>
          <p v-show="upfass" class="uptxt1">请上传5M以内大小jpg/png格式</p>
          <div class="jz">
            <span >上传报名表</span>
          </div>

        </div>
      </div>
    </div>
    <!-- 上传作品内容 -->

    <div class="grthree-upload">
      <!-- 标题 -->
      <div class="grthree-zpxinxi-title"><i></i> <span>作品上传</span></div>
      <!-- 上传四种文件 -->
      <div class="grthree-upload-all">
        <!-- 上传封面 -->
        <div class="grthree-upload-all-uplode">
          <el-upload
            class="avatar-uploader"
           :action="beforup"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            accept=".jpg,.jpeg,.png"

          >
            <img v-if="imgurl" :src="imgurl" class="avatar" />
            <i v-else class="el-icon-upload"></i>
          </el-upload>
          <p v-show="upfas" class="uptxt1">请上传830*455尺寸jpg/png格式封面</p>
          <span>上传封面</span>
        </div>
        <!-- 上传视频 -->


          <ceshi @child-event='parentEvent'></ceshi>


        <!-- 上传ppt -->
        <div class="grthree-upload-all-uplode">
          <el-upload
            class="avatar-uploader"
            action="#"
            :show-file-list="false"
            :on-success="handleAvatarSuccessPPT"
            :before-upload="beforeAvatarUploadPPT"
            accept=".pptx"
          >
            <img v-if="ppturl" :src="ppturl" class="avatar" />
            <i v-else class="el-icon-upload"></i>
          </el-upload>
          <p class="uptxt3">{{ppttxt}}</p>
          <span>上传PPT</span>
        </div>
        <!-- 上传教案 -->
        <div class="grthree-upload-all-uplode">
          <el-upload
            class="avatar-uploader"
            action="#"
            :show-file-list="false"
            :on-success="handleAvatarSuccessPDF"
            :before-upload="beforeAvatarUploadPDF"
            accept=".pdf,.doc,.docx"
          >
            <img v-if="pdfurl" :src="pdfurl" class="avatar" />
            <i v-else class="el-icon-upload"></i>
          </el-upload>
          <p class="uptxt4">{{pdftxt}}</p>
          <span>上传教案</span>
        </div>
      </div>
      <!-- 提交作品 -->
      <div @click="uplodebtns" class="three-btn-uplodeall  tijiao">
        <span>提交作品</span>
      </div>
    </div>
  </div>
</template>

<script>
import GeRenzxthree from "../css/GeRenzxthree.css";
import ceshi from './ceshi'
import plupload from "plupload";
import axios from "axios";
import { Message,Loading } from 'element-ui';

export default {
  data() {
    return {
      threezpoption: [],//作品类型
      threezpname: "", //作品名称
      threezpclass: "", //
      threetextarea: "", //内容


      imgposturlfirst:this.$apiUrl+"/index.php/teacher/upload_bm",
      imgposturlone: this.$apiUrl+"/index.php/teacher/upload", //上传封面接口地址
      //imgposturltwo: "http://192.168.1.76/index.php/teacher/uploadMp4", //上传视频接口地址
      imgposturlthree: this.$apiUrl+"/index.php/teacher/uploadPPT", //ppt接口地址
      imgposturlfour: this.$apiUrl+"/index.php/teacher/uploadPDF", //教案接口地址

      imgurl1:"",
      imgurl: "", //照地址
      mp4url: "",
      ppturl: "",
      pdfurl: "",
      tokens:JSON.parse(localStorage.getItem("userinfo")).token,
      // 四个上传的总信息提交
      uplodefirstimg:'',


       uplodeoneimg:'',
      //  uplodetwomp:'',
       uplodethreeppt:'',
       uplodefourpdf:'',
       uplodethreepptq:'',
       uplpdevideo:'',
      //  上传隐藏中间文字
      upfass:true,
      upfas:true,
      ppttxt:'请上传20M以内大小文件 全屏显示16：9',
      pdftxt:'请上传pdf格式的文件',
      beforup:this.$apiUrl+'/index.php/index/upload',
      zpid:''
    };
  },
  methods: {
    //报名表
    handleAvatarSuccessjpg(res, file) {
      this.upfass = false;
      this.imgurl1 = URL.createObjectURL(file.raw);

    },
    beforeAvatarUploadjpg(file) {
      const fd = new window.FormData()
      fd.append('file',file);
      fd.append('token',this.tokens);
        axios({
        method: "post",
        url: this.imgposturlfirst,
        data: fd,
      }).then((res) => {
          console.log('这是报名表',res.data);
          if (res.data.code == 1) {
            this.uplodefirstimg = res.data.data;
          }

        }).catch((error) => {
          console.log(error);
        });
    },



    // 封面
    handleAvatarSuccess(res, file) {
      this.upfas = false;
      this.imgurl = URL.createObjectURL(file.raw);

    },
    beforeAvatarUpload(file) {
      const fd = new window.FormData()
      fd.append('file',file);
      fd.append('token',this.tokens);
        axios({
        method: "post",
        url: this.imgposturlone,
        data: fd,
      }).then((res) => {
          console.log('这是封面',res.data);
          if (res.data.code == 1) {
            this.uplodeoneimg = res.data.data;

          }

        }).catch((error) => {
          console.log(error);
        });
    },
    // 视频
    parentEvent(data){
      // console.log('这是子传父信息',data);
      this.uplpdevideo = data.file_path;
    },
    //PPT
    handleAvatarSuccessPPT(res, file) {

    },
    beforeAvatarUploadPPT(file) {
        const fd = new window.FormData()
      fd.append('file',file);
      fd.append('token',this.tokens);
        axios({
        method: "post",
        url: this.imgposturlthree,
        data: fd,
      }).then((res) => {
        // ppt上传成功后调转化接口
          this.uplodethreepptq = res.data.data;
          if (res.data.code == 1) {
             this.ppttxt = 'ppt转化中，请稍等'
           let lodings =  Loading.service({
               lock:true,
               text:'ppt转化中...',
               spinner:'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
             });
            let path = res.data.data;
            let datappt = this.$qs.stringify({
              path:path,
              token:this.tokens
            });
            axios({
        method: "post",
        url: this.$apiUrl+'/index.php/teacher/uploadPPT_JPG',
        data: datappt,
      }).then((res) => {
          console.log('ppt转化接口',res.data);
           if (res.data.code == 1) {
             this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
             lodings.close();
                });
              this.ppttxt = 'ppt上传成功！！！'
              this.$message({
                message:'ppt上传成功',
                offset:200,
                type:'success'
              });
            this.uplodethreeppt = res.data.data;
          }


        }).catch((error) => {
          console.log(error);
        });
          }else if(res.data.code==0) {

            this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
             lodings.close();
                });
              // this.ppttxt = '请上传20M以内大小文件'
            this.$message({
              message: res.data.msg,
               offset:200,
                type:'error'
            })
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //PDF
    handleAvatarSuccessPDF(res, file) {},
    beforeAvatarUploadPDF(file) {
      const fd = new window.FormData()
      fd.append('file',file);
      fd.append('token',this.tokens);
        axios({
        method: "post",
        url: this.imgposturlfour,
        data: fd,
      }).then((res) => {

            if (res.data.code == 1) {
              this.pdftxt = '教案上传成功！！！';
              this.$message({
                message:'教案上传成功！！！',
                offset:200,
                type:'success'
              });
            this.uplodefourpdf = res.data.data;

          }
        }).catch((error) => {
          console.log(error);
        });
    },
    // 总提交
    uplodebtns() {
      let title = this.threezpname;
      let type_id = this.threezpclass.id;
      let message = this.threetextarea;
      let video = this.uplpdevideo;
      let cover_img = this.uplodeoneimg;
      let ppt = this.uplodethreepptq;
      let pptimgs = this.uplodethreeppt;
      let teach_img = this.uplodefourpdf;
      let bm_img = this.uplodefirstimg;
      const fd = new window.FormData();
       if (this.zpid !== null) {
           fd.append('id',this.zpid);
      }
      fd.append('title',title);
      fd.append('type_id',type_id);
      fd.append('token',this.tokens);
      fd.append('message',message);
      fd.append('cover_img',cover_img);
      fd.append('ppt',ppt);
      fd.append('ppt_imgs',pptimgs);
      fd.append('teach_img',teach_img);
      fd.append('video',video);
      fd.append('bg_img',bm_img);

      axios({
        method: "post",
        url: this.$apiUrl+"/index.php/teacher/CourseAdd",
        data: fd,
      }).then((res) => {
          if (res.data.code == 1) {
            // alert(res.data.msg);
            this.$message({
              message:res.data.msg,
              offset:200,
              type:'success'
            });
            this.$router.push({ name: "GeRenzxone"});
            this.$router.go(0);

          }else if (res.data.code == -1) {
            this.$confirm('请登录！', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              localStorage.clear();
              this.$router.push({path:'/'});
            })
            // localStorage.clear();
            // this.$router.push({path:'/'});
          }else if (res.data.code == 0) {
            this.$message({
              message:res.data.msg,
              offset:200
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //上传作品的类型
    typevlei() {
      let tokens = JSON.parse(localStorage.getItem("userinfo")).token;
      let typeleis = this.$qs.stringify({
        token: tokens,
      });
      axios({
        method: "post",
        url: this.$apiUrl+"/index.php/teacher/courseType",
        data: typeleis,
      })
        .then((res) => {
          this.threezpoption = res.data.data;

      // 判断个人作品的默认作品类型
          if (JSON.parse(sessionStorage.getItem('grzuop'))) {

            for (let index = 0; index <  this.threezpoption.length; index++) {

             if ( this.threezpoption[index].id ==JSON.parse(sessionStorage.getItem('grzuop')).type_id ) {

                 this.threezpclass =  this.threezpoption[index]

                return false;
             }
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    if (this.$store.state.userinfo.type==2) {
      this.typevlei();
    }
    // 判断是否从编辑进来
    if (JSON.parse(sessionStorage.getItem('grzuop'))) {
      let grzuop = JSON.parse(sessionStorage.getItem('grzuop'));
      this.threezpname = grzuop.title;
      this.threetextarea = grzuop.message;
      this.zpid = grzuop.id;
    }
  },
  components:{ceshi}
};
</script>

<style >
 .brr{
    margin-top: 0.15rem;
}
.three-btn-uplodeall {

    margin: 0.35rem auto !important;
}
.grthree-zpxinxi-data {
    margin-top: 0.15rem;
}
.grthree-zpxinxi-data-name {
    margin-top: 0.05rem;
}
.grthree-upload-all {

    margin-top: 0.15rem !important;
}
.grthree-zpxinxi-data-text {
    margin-top: 0.15rem;
}
/* .grthree-upload {
    margin-top: 0.36rem !important;
} */
.gerenzxthree {
    width: 12.69rem;
    /* height: 12rem !important; */
    /* margin: 0 auto 0 2.55rem; */
    background-color: #fff;
}
.gerenzxone {
    width: 100%;
    height: 13rem !important;
    overflow: hidden;
    background-color: #f3f3f3;
    padding-bottom: 1.4rem;
}

.three-btn-uplodeall {

    margin: 0 auto;
}
.grthree-upload-all-uplode span {

    line-height: 0.4rem !important;
}
.upvdeo {

    line-height: 0.4rem !important;
}

.jz{
text-align: center;
}

.gerenzxone {
    padding-bottom: 1.5rem !important;
}


</style>



// WEBPACK FOOTER //
// src/components/GeRenzxthree.vue